import { FileError } from "react-dropzone";

export interface FormModel {
    paymentmethod: string;
    phonenumberapp: string;
    ticketnumber: string;
    cardnumber: string;
    delay: string;
    compensation: string;
    refundpreference: string;
    taxireceipt: UploadableFile[];
    distance: string;
    cartravelfrom: string;
    cartravelto: string;
    carlicenceplate: string;
    carexpenses: UploadableFile[];
    valuecodeemail: string;
    clearingnumber: string;
    accountnumber: string;
    firstname: string;
    lastname: string;
    streetaddress: string;
    zipcode: string;
    postaladdress: string;
    phonenumbercontact: string;
    emailcontact: string;
    moreinfo: string;
    journey: string;
    selectedJourney: SelectedJourney,
}

interface SelectedJourney {
    fromName: string;
    toName: string;
    date: string;
    travelTime: string;
    journeyKey: string;
    line: string;
    switches: string;
    unformattedDate: string,
}

interface Stop {
    PlaceName: string;
    OgtType: string;
    Ll: [number, number];
    Id: number;
}

export interface TravelSearchModel {
    selectedJourneyFrom: Stop | null;
    selectedJourneyTo: Stop | null;
    journeyDate: string;
    journeyTime: string;
}


export interface UploadableFile {
    id: number;
    file: File;
    data: string;
    size: number;
    errors: FileError[];
}

export enum TimePeriod {
    Year,
    Month,
    Week,
    Day,
    Hour,
    Minute,
    Second,
    MilliSecond,
}
